import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import ReportTable from '../../../components/ReportTable';
import DoughnutChart from '../../../components/chart/DoughnutChart';
import NoDataComponent from '../../../common/NoDataComponent'; // Import the new component

const DoughnutReportView = ({ data, reportHeading, tableTitle, tableDataColumn }) => (
  <Grid container direction="row" justifyContent="center" alignItems="center" style={{ paddingTop: '8%' }}>
    <Grid item xs={12} className="report-heading" style={{ marginTop: '10px' }}>
      {reportHeading}
    </Grid>

    {data?.table?.length > 0 ? (
      <>
        <Grid item md={6} sm={6} xs={12}>
          <DoughnutChart data={data?.graph} />
        </Grid>

        <Grid item md={6} sm={6} xs={12}>
          <ReportTable tableTitle={tableTitle} data={data?.table} dataColumn={tableDataColumn} />
        </Grid>
      </>
    ) : (
      <>
        <NoDataComponent />
      </>
    )}
  </Grid>
);

DoughnutReportView.propTypes = {
  data: PropTypes.object.isRequired,
  reportHeading: PropTypes.string.isRequired,
  tableTitle: PropTypes.string.isRequired,
  tableDataColumn: PropTypes.string.isRequired,
};

export default DoughnutReportView;
